"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckCourtainSide = function SvgIconTruckCourtainSide(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck courtain side icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Courtain Side Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.119 14.564v12.231h-2.601V13.269zm1.343-.618l1.353-.692 1.333.651v12.89h-2.686zm4.03.615l.074.036 1.94-1.343c.448.2.672.424.672.672v12.869h-2.686zm13.603 2.721L44 24v8.397h-3.272c0 2.778-2.195 5.035-4.904 5.035-2.71 0-4.905-2.257-4.905-5.035H17.081c0 2.778-2.198 5.035-4.907 5.035-2.708 0-4.904-2.257-4.904-5.035H4v-20.92a.91.91 0 01.91-.91h25.1a.91.91 0 01.91.91V28.03h.857V17.282zm-3.271 17.633c1.354 0 2.453-1.13 2.453-2.518 0-1.395-1.099-2.518-2.453-2.518-1.356 0-2.453 1.123-2.453 2.518 0 1.387 1.097 2.518 2.453 2.518zM9.72 32.397c0 1.387 1.099 2.518 2.453 2.518 1.353 0 2.453-1.13 2.453-2.518 0-1.395-1.1-2.518-2.453-2.518-1.354 0-2.453 1.123-2.453 2.518zM34.19 24h7.298l-3.21-4.197H34.19zm-4.668 4.138V13.926a2.015 2.015 0 00-2.014-2.015H7.443a2.015 2.015 0 00-2.015 2.015v14.212z"
  }));
};

var _default = SvgIconTruckCourtainSide;
exports.default = _default;